import React, { useState, useEffect } from 'react';
import IconButton from '@mui/material/IconButton';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';

const ArrowTop = () => {
    const [isVisible, setIsVisible] = useState(false);

    // Vérifie si la flèche doit être affichée ou non
    useEffect(() => {
        const checkVisibility = () => {
            if (window.pageYOffset > 300) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };
        window.addEventListener('scroll', checkVisibility);
        return () => window.removeEventListener('scroll', checkVisibility);
    }, []);

    // Remonte en haut de la page
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    return (
        isVisible && (
            <IconButton
                onClick={scrollToTop}
                style={{
                    position: 'fixed',
                    bottom: '2%',
                    right: '2%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    color: 'white',
                    zIndex: 2500
                }}
            >
                <ArrowUpwardIcon />
            </IconButton>
        )
    );
};

export default ArrowTop;
